import { useMemo } from 'react';

import { useIsAllowedPermission, useProfile } from '@mint-lib/profile-helpers';

import useSuggestionVersion from './useSuggestionVersion.js';

const AIRFRANCE_ID = 179; /*FYI: Hiding accept/reject for AIRFRANCE company is request from business https://mint-ai.atlassian.net/browse/PDT-73001*/

const useSuggestionPermissions = () => {
  const { profileService, getCompanyField } = useProfile();
  const { isAlphaVersionEnabled } = useSuggestionVersion();

  const isFullControl = useIsAllowedPermission(
    'notificationsFeature:full_control',
  );
  const currentCompany = getCompanyField('id');

  const isOwner = useMemo(
    () => profileService.getProfileData()?.isOwner,
    [profileService],
  );

  const isAcceptRejectAllowed = useMemo(
    () => isFullControl && currentCompany !== AIRFRANCE_ID,
    [isFullControl, currentCompany],
  );

  const isPublishAllowed = useMemo(
    () => isAlphaVersionEnabled && isOwner,
    [isAlphaVersionEnabled, isOwner],
  );

  const isProcessingAllowed = useMemo(() => isOwner, [isOwner]);

  return {
    isAcceptRejectAllowed,
    isPublishAllowed,
    isProcessingAllowed,
  };
};

export default useSuggestionPermissions;
